import React from 'react';
import ZuruuDans from './zuruuDans';

const PageList = () => <ZuruuDans />;

export default PageList;
